import Component from './LocalesSwitcher.container';
import config from './LocalesSwitcher.config';

export { Component, config };

export default Component;
